import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {Tag} from '@/components/ui/tag'
import {Hint} from '@/components/ui/hint'
import {PlanValidacionDialog} from '@/components/bateria/plan-validacion-dialog'
import {HelpIcon} from '@/components/help-icon'
import {usePlanValidacion} from '@/hooks/bateria/use-bateria-plan-validacion'
import {formatDateOnly} from '@/lib/risk'

/** G17′ (diseño v2 §0.1): un hecho sobre el catálogo, no de un lote. Registrar nunca gatea nada: solo
 * habilita la línea que el informe imprime. */
export function PlanValidacionTarjeta() {
  const {t} = useTranslation()
  const {data: vigente, isLoading} = usePlanValidacion()
  const [abierto, setAbierto] = useState(false)

  if (isLoading) return null

  return (
    <section
      className="surface flex flex-wrap items-center justify-between gap-3 px-5 py-3.5"
      data-testid="plan-validacion-tarjeta">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <Tag tone={vigente ? 'green' : 'amber'} data-testid="plan-validacion-estado">
            {t(vigente ? 'admin.bateria.planValidacion.tagValidado' : 'admin.bateria.planValidacion.tagSinValidar')}
          </Tag>
          {/* T2: un chip no se ve pulsable — el «i» va AL LADO, nunca sobre el chip. */}
          {!vigente && (
            <HelpIcon
              label={t('common.help.iconLabelFor', {campo: t('admin.bateria.planValidacion.tagSinValidar')})}
              testId="plan-validacion-sin-validar-tip">
              {t('admin.bateria.planValidacion.sinValidarTip')}
            </HelpIcon>
          )}
          <span className="text-sm font-medium text-foreground">{t('admin.bateria.planValidacion.title')}</span>
        </div>
        {vigente ? (
          <Hint className="mt-1" testId="plan-validacion-detalle">
            {t('admin.bateria.planValidacion.lineaCompleta', {
              nombre: vigente.validado_por,
              licencia: vigente.licencia,
              fecha: formatDateOnly(vigente.validado_en),
            })}
          </Hint>
        ) : null}
      </div>
      <Button
        size="sm"
        variant="outline"
        data-testid="plan-validacion-registrar-abrir"
        onClick={() => setAbierto(true)}>
        {t('admin.bateria.planValidacion.registrar')}
      </Button>
      <PlanValidacionDialog open={abierto} onOpenChange={setAbierto} />
    </section>
  )
}
